"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultVirtualOptions = exports.virtualTag = exports.virtualRefererPath = exports.virtualRefererDomain = exports.virtualParent = exports.virtualViewMode = exports.virtualBreakpoints = exports.virtualContentId = exports.virtualEventType = exports.getId = exports.getPrefix = exports.PREFIX_TAG = exports.PREFIX_REFERER_PATH = exports.PREFIX_REFERER_DOMAIN = exports.PREFIX_PARENT_URL = exports.PREFIX_PARENT_ID = exports.PREFIX_BREAKPOINT_LARGER_EQUAL = exports.PREFIX_BREAKPOINT_SMALLER_EQUAL = exports.PREFIX_VIEWMODE = exports.PREFIX_ID = exports.PREFIX_EVENT_TYPE = exports.PREFIX_CONNECTOR = void 0;
exports.PREFIX_CONNECTOR = "-->";
exports.PREFIX_EVENT_TYPE = "event_type";
exports.PREFIX_ID = "content_id";
exports.PREFIX_VIEWMODE = "viewmode";
exports.PREFIX_BREAKPOINT_SMALLER_EQUAL = "breakpoint_smaller_equal";
exports.PREFIX_BREAKPOINT_LARGER_EQUAL = "breakpoint_larger_equal";
exports.PREFIX_PARENT_ID = "parent_id";
exports.PREFIX_PARENT_URL = "parent_url";
exports.PREFIX_REFERER_DOMAIN = "referer_domain";
exports.PREFIX_REFERER_PATH = "referer_path";
exports.PREFIX_TAG = "tag";
var getPrefix = function (key) { return key + exports.PREFIX_CONNECTOR; };
exports.getPrefix = getPrefix;
var getId = function (key, value) { return (0, exports.getPrefix)(key) + value; };
exports.getId = getId;
var virtualEventType = function (value) {
    if (!value)
        return [];
    return [
        {
            condition: {
                field: "event_type",
                value: value,
                compare: "=",
            },
            group: "",
            title: "Event › " + value,
            id: (0, exports.getId)(exports.PREFIX_EVENT_TYPE, value)
        }
    ];
};
exports.virtualEventType = virtualEventType;
var virtualContentId = function (value) {
    if (!value)
        return [];
    return [
        {
            condition: {
                field: "content_id",
                value: value,
                compare: "=",
            },
            group: "",
            title: "ID › " + value,
            id: (0, exports.getId)(exports.PREFIX_ID, value)
        }
    ];
};
exports.virtualContentId = virtualContentId;
var virtualBreakpoints = function (value) {
    if (!value || value !== parseInt(value) + "")
        return [];
    return [
        {
            condition: {
                field: "breakpoint",
                value: value + "px",
                compare: "<",
            },
            group: "",
            title: "Breakpoint >= " + value,
            id: (0, exports.getId)(exports.PREFIX_BREAKPOINT_LARGER_EQUAL, value)
        },
        {
            condition: {
                field: "breakpoint",
                value: value + "px",
                compare: "<=",
            },
            group: "",
            title: "Breakpoint <= " + value,
            id: (0, exports.getId)(exports.PREFIX_BREAKPOINT_SMALLER_EQUAL, value),
        }
    ];
};
exports.virtualBreakpoints = virtualBreakpoints;
var virtualViewMode = function (value) {
    if (!value)
        return [];
    return [
        {
            condition: {
                field: "viewmode",
                value: value,
                compare: "=",
            },
            group: "",
            title: "Viewmode › " + value,
            id: (0, exports.getId)(exports.PREFIX_VIEWMODE, value)
        }
    ];
};
exports.virtualViewMode = virtualViewMode;
var virtualParent = function (value) {
    if (!value)
        return [];
    return [
        {
            condition: {
                field: "parent_id",
                value: value,
                compare: "=",
            },
            group: "",
            title: "Parent ID › " + value,
            id: (0, exports.getId)(exports.PREFIX_PARENT_ID, value),
        },
        {
            condition: {
                field: "parent_url",
                value: value,
                compare: "=",
            },
            group: "",
            title: "Parent Url › " + value,
            id: (0, exports.getId)(exports.PREFIX_PARENT_URL, value),
        }
    ];
};
exports.virtualParent = virtualParent;
var virtualRefererDomain = function (value) {
    if (value.match(/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/i)) {
        return [
            {
                condition: {
                    field: "referer_domain",
                    value: value,
                    compare: "=",
                },
                group: "",
                title: "Referer Domain › " + value,
                id: (0, exports.getId)(exports.PREFIX_REFERER_DOMAIN, value),
            },
        ];
    }
    return [];
};
exports.virtualRefererDomain = virtualRefererDomain;
var virtualRefererPath = function (value) {
    if (!value)
        return [];
    return [
        {
            condition: {
                field: "referer_path",
                value: value,
                compare: "=",
            },
            group: "",
            title: "Referer Path › " + value,
            id: (0, exports.getId)(exports.PREFIX_REFERER_PATH, value),
        }
    ];
};
exports.virtualRefererPath = virtualRefererPath;
var tags = __spreadArray([], Array(9), true).map(function (_, index) { return ({
    field: "tag" + (index + 1),
    value: "",
    compare: "=",
}); });
var virtualTag = function (value) {
    if (!value)
        return [];
    return [
        {
            condition: {
                entries: __spreadArray([], tags.map(function (t) { return (__assign(__assign({}, t), { value: value })); }), true),
                relation: "OR",
            },
            group: "",
            title: "Tag › " + value,
            id: (0, exports.getId)(exports.PREFIX_TAG, value),
        }
    ];
};
exports.virtualTag = virtualTag;
var defaultVirtualOptions = function (value) {
    if (!value)
        return [];
    return __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (0, exports.virtualEventType)(value), true), (0, exports.virtualContentId)(value), true), (0, exports.virtualViewMode)(value), true), (0, exports.virtualRefererDomain)(value), true), (0, exports.virtualRefererPath)(value), true), (0, exports.virtualBreakpoints)(value), true), (0, exports.virtualTag)(value), true), (0, exports.virtualParent)(value), true).map(function (it) { return (__assign(__assign({}, it), { isVirtual: true })); });
};
exports.defaultVirtualOptions = defaultVirtualOptions;
